import AppInfo from "./helpers/appInfo";

const dev = {
  env: "dev",
  label: "Development",
  logger: true,
};

const test = {
  env: "test",
  label: "Test",
  logger: true,
};

const prod = {
  env: "prod",
  label: "Staging",
  logger: false,
};

const apis = {
  auth: {
    login: "/api/Account/Login",
    logout: "/v2/auth/logout",
    me: "/api/Account/User",
    refreshToken: "/v2/auth/refreshToken",
    sendResetPassword: "/api/Account/SendResetPassword",
    resetPassword: "/api/Account/ResetPassword",
    newToken: "/api/Account/token",
  },
  dossiers: {
    dossier: "/api/Dossier",
  },
  users: {
    user: "/api/User",
  },
  import: {
    importXLS: "/api/Import/XLS/",
    getImportUserTemplate: "/api/Import/XLS/ImportUserTemplate",
  },
  products: {
    catalog: "/api/Agency/:agencyId/CatalogXLS",
  },
  customers: {
    list: "/api/Customer",
  },
};

const env_config = function () {
  switch (AppInfo.env) {
    case "production":
      return prod;
    case "test":
      return test;
    case "development":
      return dev;
    default:
      return dev;
  }
};

const publicConfig: {
  start: string;
  env: string;
  label: string;
  logger: boolean;
  apiBaseurl: string;
  appBaseurl: string;
  defaultLocale: string;
  forceLocale?: string;
  enableLocales?: string[];
  localeCookieName: string;
  localeDictUrl?: string;
  firebaseConfig?: object;
} & {
  [x: string]: string | number | boolean | Date | JSON | JSON[];
} & typeof Config = {
  start: new Date().toISOString(),
  env: "dev",
  label: "Development",
  logger: false,
  defaultLocale: "it",
  localeCookieName: "locale",
  ...(window as any).config,
};

const Config = {
  app_name: AppInfo.name,
  app_version: AppInfo.version,
  maintenance_mode: false,
  roleScopes: {
    SUPERADMINISTRATOR: {
      dossiers: ["create", "read", "update", "delete", "any"],
      setup: ["create", "read", "update", "delete", "any"],
      users: ["create", "read", "update", "delete", "any"],
    },
    ADMINISTRATOR: {
      dossiers: ["create", "read", "update", "delete", "any"],
      users: ["create", "read", "update", "delete", "any"],
    },
    AGENT: {
      dossiers: ["create", "read", "update", "delete"],
    },
  },
  regex: {
    validString: /.{2,}/,
    validNumber:
      /^\+?\d{3,4}?[-.\\\s]?\(?\d{1,3}?\)?[-.\\\s]?\d{1,4}[-.\\\s]?\d{1,4}[-.\\\s]?\d{1,9}$/,
    email:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[1-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password:
      /^(?=(.*[a-z]){2,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()-__+.]){1,}).{8,}$/,
    year: /^\d{5}$/g,
    postalCode: /^\d{6}$/,
    piva: /^[1-9]{11}$/,
    phone: { it: /^[1|3]{1}[0-9]{5,10}$/ },
    fiscalCode:
      /^([A-Za-z]{7}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z])$/,
    iban: /^(it|IT)[1-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/,
  },
  apis,
  start: new Date().toISOString(),
};

const config = { ...Config, ...publicConfig, ...env_config() };
export default config;
